// Campus photo for /colleges/loyola-marymount-university: CC BY-SA 4.0, by Chris troutman, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ALMU_Pride_Park_and_George_Page_Stadium.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/loyola-marymount-university/; credited under the photo.
const photo = {
    "slug": "loyola-marymount-university",
    "alt": "The entrance to George C. Page baseball stadium and Pride Park, framed by palm trees, on the Loyola Marymount University campus in Los Angeles",
    "src": "/colleges/loyola-marymount-university/campus-1600.webp",
    "srcSmall": "/colleges/loyola-marymount-university/campus-800.webp",
    "srcMid": "/colleges/loyola-marymount-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/loyola-marymount-university/og.jpg",
    "title": "LMU Pride Park and George Page Stadium",
    "author": "Chris troutman",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ALMU_Pride_Park_and_George_Page_Stadium.jpg",
    "read": "2026-10-01"
};

export default photo;
